import type { KarmaBirthDate } from "@/lib/karma/types";

export function birthDateToDate(birthDate: KarmaBirthDate) {
  return new Date(birthDate.year, birthDate.month - 1, birthDate.day);
}

export function getAge(birthDate: KarmaBirthDate, now = new Date()) {
  const dob = birthDateToDate(birthDate);

  let age = now.getFullYear() - dob.getFullYear();
  const m = now.getMonth() - dob.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < dob.getDate())) {
    age -= 1;
  }

  return Math.max(0, age);
}
